import { isEmail, isRequired } from 'evcharging/app/validation/validators';
import { STAY_UPDATED_ENDPOINT } from 'evcharging/app/server/endpoints';
import { httpClient } from 'evcharging/app/client/index';

const validators = {
  email: [isRequired, isEmail],
};

const sendStayUpdated = (payload: Record<string, string>) =>
  httpClient()
    .setBody(payload)
    .setValidators(validators)
    .post(STAY_UPDATED_ENDPOINT);

export default sendStayUpdated;
